import React from "react";
import { DateTimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import AlarmIcon from "@material-ui/icons/AddAlarm";
import { InputAdornment, IconButton } from "@material-ui/core";
import DateFnsUtils from "@date-io/date-fns"; // choose your lib

const CustomDatePicker = ({ onChange, name, value }) => {
  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <DateTimePicker
        name={name}
        variant="inline"
        ampm={false}
        value={value}
        allowKeyboardControl={true}
        onChange={onChange}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton>
                <AlarmIcon />
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
    </MuiPickersUtilsProvider>
  );
};

export default CustomDatePicker;
